// Generate a branded Registration Number card as a PNG and trigger download.
// This does NOT export the deed itself — only the registration number for record-keeping.

export async function downloadRegistrationCard(order) {
  const W = 1200;
  const H = 675;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  // Background
  const grad = ctx.createLinearGradient(0, 0, W, H);
  grad.addColorStop(0, "#050507");
  grad.addColorStop(1, "#0f0d16");
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, W, H);

  // Star sprinkle
  for (let i = 0; i < 90; i++) {
    ctx.fillStyle = `rgba(255,255,255,${0.15 + Math.random() * 0.55})`;
    const s = Math.random() < 0.15 ? 2 : 1;
    ctx.fillRect(Math.random() * W, Math.random() * H, s, s);
  }

  // Ambient gold glow (right side)
  const glow = ctx.createRadialGradient(W * 0.85, H * 0.5, 20, W * 0.85, H * 0.5, 500);
  glow.addColorStop(0, "rgba(212,175,55,0.35)");
  glow.addColorStop(1, "rgba(212,175,55,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);

  // Outer inner border (glass feel)
  ctx.strokeStyle = "rgba(255,255,255,0.18)";
  ctx.lineWidth = 1;
  ctx.strokeRect(40, 40, W - 80, H - 80);
  ctx.strokeStyle = "rgba(212,175,55,0.4)";
  ctx.lineWidth = 1;
  ctx.strokeRect(52, 52, W - 104, H - 104);

  // Brand mark
  ctx.beginPath();
  ctx.arc(100, 100, 22, 0, Math.PI * 2);
  ctx.fillStyle = "#D4AF37";
  ctx.fill();
  ctx.fillStyle = "#0A0A0C";
  ctx.font = "700 24px Manrope, sans-serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("T", 100, 101);

  ctx.textAlign = "left";
  ctx.textBaseline = "alphabetic";
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "800 32px 'Cabinet Grotesk', Manrope, sans-serif";
  ctx.fillText("Teuralink", 138, 110);

  ctx.fillStyle = "rgba(255,255,255,0.6)";
  ctx.font = "500 12px 'Space Mono', monospace";
  ctx.fillText("COMMEMORATIVE REGISTRY · EST. 2026", 138, 130);

  // Courier notice (bold, prominent)
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "700 16px Manrope, sans-serif";
  ctx.fillText("Your printed certificate will be couriered to you shortly.", 80, 205);

  // Overline
  ctx.fillStyle = "#D4AF37";
  ctx.font = "500 14px 'Space Mono', monospace";
  ctx.fillText("PLOT REGISTRATION NUMBER", 80, 250);

  // Registration number (BIG)
  ctx.fillStyle = "#D4AF37";
  ctx.font = "700 74px 'Space Mono', monospace";
  ctx.fillText(order.registration_number, 80, 325);

  // Divider
  ctx.strokeStyle = "rgba(255,255,255,0.15)";
  ctx.beginPath();
  ctx.moveTo(80, 360);
  ctx.lineTo(W - 80, 360);
  ctx.stroke();

  // Details grid
  const drawItem = (label, value, x, y) => {
    ctx.fillStyle = "rgba(255,255,255,0.55)";
    ctx.font = "500 11px 'Space Mono', monospace";
    ctx.fillText(label.toUpperCase(), x, y);
    ctx.fillStyle = "#FFFFFF";
    ctx.font = "500 22px Manrope, sans-serif";
    ctx.fillText(String(value), x, y + 32);
  };

  drawItem("Registered To", order.certificate_name || order.customer.full_name, 80, 400);
  drawItem("Planet", order.planet === "moon" ? "The Moon" : "Mars", 500, 400);
  drawItem("Plot Location", order.marker_label, 80, 470);
  drawItem("Plot Size", `${order.acres} ${order.acres === 1 ? "Acre" : "Acres"}`, 500, 470);
  drawItem(
    "Coordinates",
    `LAT ${Number(order.lat).toFixed(2)}° · LON ${Number(order.lon).toFixed(2)}°`,
    80,
    540
  );
  drawItem(
    "Registered On",
    new Date(order.purchase_date).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    }),
    500,
    540
  );

  // Footer disclaimer
  ctx.fillStyle = "rgba(255,255,255,0.45)";
  ctx.font = "400 12px Manrope, sans-serif";
  ctx.fillText(
    "This is a commemorative novelty registration and does not convey legal ownership of any celestial body.",
    80,
    H - 60
  );
  ctx.fillStyle = "rgba(255,255,255,0.55)";
  ctx.font = "500 11px 'Space Mono', monospace";
  ctx.fillText("teuralink.com  ·  verify at /verify", 80, H - 40);

  // Download
  const url = canvas.toDataURL("image/png");
  const a = document.createElement("a");
  a.href = url;
  a.download = `Teuralink_${order.registration_number}.png`;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
